const removeOnlyParams = [
  '_', // unknown
  'cid', // unknown
  'noapp', // internal
  'o', // internal
  'page', // internal
  'pnl', // internal
  'ps', // internal
]

export const trackingParams = [
  '_gl', // Google Analytics
  'adid', // Google Ads
  'awc', // Awin
  'clangct', // Clang
  'CT', // unknown
  'dclid', // Google Floodlight / Campaign Manager 360
  'emailcode', // internal
  'epik', // Pinterest
  'fbclid', // Facebook (Meta)
  'gad', // Google Ads
  'gad_campaignid', // Google Ads
  'gad_source', // Google Ads
  'gbraid', // Google Ads
  'gclid', // Google Ads
  'gclsrc', // Google Ads
  'msclkid', // Microsoft Bing
  'oppref', // OpenAI
  'ppcp_platform', // Lunio
  'qpg', // Stape Google Ads
  'qpm', // Stape Microsoft Bing
  'ranEAID', // Rakuten
  'ranMID', // Rakuten
  'ranSiteID', // Rakuten
  'rdt_cid', // Reddit
  'referrer', // internal
  'sort', // internal
  'srsltid', // Google
  'ttclid', // TikTok
  'tw_specials', // internal
  'u1', // Rakuten
  'utm', // Google Analytics
  'utm_campaign', // Google Analytics
  'utm_content', // Google Analytics
  'utm_creative_format', // Google Analytics
  'utm_id', // Google Analytics
  'utm_keyword', // Google Analytics
  'utm_marketing_tactic', // Google Analytics
  'utm_medium', // Google Analytics
  'utm_source', // Google Analytics
  'utm_source_platform', // Google Analytics
  'utm_term', // Google Analytics
  'voucher', // unknown
  'wbraid', // Google Ads
]

export const trackingParamSet = new Set(trackingParams)

export const filterParams: string[] = [...removeOnlyParams, ...trackingParams]
